<div class="content">
	<div class="md-menu-header">{{getGlobal('PopupHeaderSort')}}</div>
	<ng-container *ngFor="let s of uiSort; let i = index;">
		<h3 *ngIf="i == 0 || i > 0 && s.sortGroup != uiSort[i-1].sortGroup">{{getTranslation(s.sortGroup)}}</h3>
		<div class="md-menu-item-sort" [tooltip]="s.uiTooltip">
			<i class="fad fa-fw"
			   [ngClass]="{'fa-sort' : s.uiValue == 0,'fa-sort-up' : s.uiValue == 1,'fa-sort-down' : s.uiValue == 2 }"></i>
			{{getTranslation(s.uiCaption)}}
		</div>
	</ng-container>
</div>
